export const ConquestTypes = {
    notConverted: 1,
    converted: 2,
    creditConvert: 3
}